export default "__VITE_ASSET__D43PUXUl__"